import type { VariantProps } from "class-variance-authority";
import type { SVGProps } from "react";

import { cn } from "@homeinstead/ui";
import { cva } from "class-variance-authority";
import React from "react";
import CloseSVG from "./Close.svg";

const closeStyles = cva("", {
  defaultVariants: {
    variant: "default",
  },
  variants: {
    variant: {
      default: "",
    },
  },
});

export interface CloseProps
  extends SVGProps<SVGSVGElement>,
    VariantProps<typeof closeStyles> {
  className?: string;
}

export default function Close({ className, variant, ...props }: CloseProps) {
  return (
    <CloseSVG className={cn(closeStyles({ className, variant }))} {...props} />
  );
}
